import React from "react";
import { createRoutesFromElements, Route } from "react-router";
import RootLayout from "../components/RootLayout";
import Login from "../pages/auth/Login";
import PrivacyPolicyAcceptance from "../pages/auth/PrivacyPolicyAcceptance";
import TeacherSignup from "../pages/auth/TeacherSignup";
import TeacherSignupRedirect from "../components/TeacherSignupRedirect";
import RootRedirect from "../components/RootRedirect";
import RouteErrorBoundary from "../components/RouteErrorBoundary";
import { adminRoutes } from "./adminRoutes";
import { teacherRoutes } from "./teacherRoutes";

const NotFound = React.lazy(() => import("../pages/NotFound"));

/** The app's route tree; App passes it to createBrowserRouter, tests to createMemoryRouter. */
export const appRoutes = createRoutesFromElements(
  <Route element={<RootLayout />} errorElement={<RouteErrorBoundary fullScreen />}>
    <Route path="/" element={<RootRedirect />} />
    <Route path="/auth/login" element={<Login />} />
    <Route path="/auth/privacy-policy" element={<PrivacyPolicyAcceptance />} />
    <Route path="/auth/signup/teacher" element={<TeacherSignup />} />
    <Route path="/signup/teacher" element={<TeacherSignupRedirect />} />

    {adminRoutes}
    {teacherRoutes}

    <Route path="*" element={<NotFound />} />
  </Route>,
);
